/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

export const DEFAULT_ALERTS_TIME_IN_MILLISECONDS = 5000

export enum ALERTS {
  error = 'error',
  success = 'success',
  info = 'info',
  warning = 'warning',
  successBillingInfoChanged = 'successBillingInfoChanged',
  successBusinessDetailsChanged = 'successBusinessDetailsChanged',
  successPaymentDetailsChanged = 'successPaymentDetailsChanged',
  successChangeSubscription = 'successChangeSubscription',
  successResendConfirmEmail = 'successResendConfirmEmail',
  billingAddressIsNotValid = 'billingAddressIsNotValid',
  shippingAddressIsNotValid = 'shippingAddressIsNotValid',
  successUpdateCard = 'successUpdateCard',
  addressIsNotValid = 'addressIsNotValid',
  profileShippingFormError = 'profileShippingFormError',
  profileBillingFormError = 'profileBillingFormError',
  profileCreditCardIssue = 'profileCreditCardIssue',
  successEmailConfirmed = 'successEmailConfirmed',
  successChangeEmailConfirmed = 'successChangeEmailConfirmed',
  successMessageSent = 'successMessageSent',
  successLeaveEmail = 'successLeaveEmail',
  successChangePassword = 'successChangePassword',
  passwordUsedBefore = 'passwordUsedBefore',
  noAgreement = 'noAgreement',
  signUpSuccesfull = 'signUpSuccesfull',
}

enum ALERT_TYPES {
  success = 'success',
  info = 'info',
  warning = 'warning',
  danger = 'danger',
}

export const ALERTS_CONFIG = {
  [ALERTS.error]: {
    name: ALERTS.error,
    type: ALERT_TYPES.danger,
  },
  [ALERTS.success]: {
    name: ALERTS.success,
    type: ALERT_TYPES.success,
  },
  [ALERTS.warning]: {
    name: ALERTS.warning,
    type: ALERT_TYPES.warning,
  },
  [ALERTS.info]: {
    name: ALERTS.info,
    type: ALERT_TYPES.info,
  },
  [ALERTS.successBillingInfoChanged]: {
    name: ALERTS.successBillingInfoChanged,
    type: ALERT_TYPES.success,
  },
  [ALERTS.successChangeSubscription]: {
    name: ALERTS.successChangeSubscription,
    type: ALERT_TYPES.success,
  },
  [ALERTS.successResendConfirmEmail]: {
    name: ALERTS.successResendConfirmEmail,
    type: ALERT_TYPES.success,
  },
  [ALERTS.billingAddressIsNotValid]: {
    name: ALERTS.billingAddressIsNotValid,
    type: ALERT_TYPES.danger,
  },
  [ALERTS.shippingAddressIsNotValid]: {
    name: ALERTS.shippingAddressIsNotValid,
    type: ALERT_TYPES.danger,
  },
  [ALERTS.successUpdateCard]: {
    name: ALERTS.successUpdateCard,
    type: ALERT_TYPES.success,
  },
  [ALERTS.profileShippingFormError]: {
    name: ALERTS.error,
    type: ALERT_TYPES.danger,
  },
  [ALERTS.profileBillingFormError]: {
    name: ALERTS.error,
    type: ALERT_TYPES.danger,
  },
  [ALERTS.profileCreditCardIssue]: {
    name: ALERTS.error,
    type: ALERT_TYPES.danger,
  },
  [ALERTS.successEmailConfirmed]: {
    name: ALERTS.successEmailConfirmed,
    type: ALERT_TYPES.success,
  },
  [ALERTS.successChangeEmailConfirmed]: {
    name: ALERTS.successChangeEmailConfirmed,
    type: ALERT_TYPES.success,
  },
  [ALERTS.successMessageSent]: {
    name: ALERTS.successMessageSent,
    type: ALERT_TYPES.success,
  },
  [ALERTS.successLeaveEmail]: {
    name: ALERTS.successLeaveEmail,
    type: ALERT_TYPES.success,
  },
  [ALERTS.successPaymentDetailsChanged]: {
    name: ALERTS.successPaymentDetailsChanged,
    type: ALERT_TYPES.success,
  },
  [ALERTS.successChangePassword]: {
    name: ALERTS.successChangePassword,
    type: ALERT_TYPES.success,
  },
  [ALERTS.successBusinessDetailsChanged]: {
    name: ALERTS.successBusinessDetailsChanged,
    type: ALERT_TYPES.success,
  },
  [ALERTS.passwordUsedBefore]: {
    name: ALERTS.passwordUsedBefore,
    type: ALERT_TYPES.danger,
  },
  [ALERTS.noAgreement]: {
    name: ALERTS.noAgreement,
    type: ALERT_TYPES.danger,
  },
  [ALERTS.signUpSuccesfull]: {
    name: ALERTS.signUpSuccesfull,
    type: ALERT_TYPES.info,
  },
}

export enum ALERT_PARTS {
  headline = 'headline',
  message = 'message',
}
